export default "__VITE_ASSET__DEi9FG5O__"